import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SnackbarProvider } from "notistack";
import AdminRoutes from "./routes/AdminRoutes";

const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SnackbarProvider>
          <Suspense fallback={<div>Loading...</div>}>
            <AdminRoutes />
          </Suspense>
        </SnackbarProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;

